const details = {
    name: "شهر درب",
    enName: "shahr darb",
    description: "بزرگترین تولیدکننده و فروشنده درب در کرج",

    supportDescription: "",
    workingHours: [],
    "__choose among these__": "",
    enamadTag: "",
    samandehiTag: "",
    ZarinpalLink: "https://www.zarinpal.com/webservice/TrustCode",
    developmentCompanyWebsite: {
        name: "ساخت سایت صنایع چوب",
        link: "https://barantm.com/landing/woodshop-website-design"
    }
}

export default details;
